(ns teamoesterreich.user-mode.ui-helper.preview-modal
  (:require
    [clojure.string :as str]
    [reagent-material-ui.components :as mui]
    [reagent-material-ui.icons.keyboard-arrow-left :refer [keyboard-arrow-left]]
    [reagent-material-ui.icons.open-in-browser :refer [open-in-browser]]
    [reagent.core :as r]
    ))


(defn modal [url !show]

  [mui/modal
   {
    :aria-labelledby  "simple-modal-title"
    :aria-describedby "simple-modal-description"
    :style            {:display        "flex"
                       :marginRight    "auto"
                       :marginLeft     "auto"
                       :alignItems     "center"
                       :justifyContent "center"}
    :open             (or @!show false)

    }


   [:div
    {:class "modal"
     :title "Klicken zum Schließen"}

    (when url
      [:img {:src (str url)
             :onClick #(reset! !show false)
             :style {:position "relative" :float "right"
                     :maxWidth "min(550px, 70vw"
                     :maxHeight "min(550px, 70vh"
                     :minWidth "260px"
                     :minHeight "260px"
                     }  :alt "Ansicht"}]
      )
    [:br]
    [mui/button {:onClick   #(reset! !show false)
                 :startIcon (r/as-element [keyboard-arrow-left])
                 } "Schließen"]
    [:a {:href (str/replace (str url) "/preview" "") :target "_blank"}
     [mui/button {:startIcon (r/as-element [open-in-browser])
                  } "Neuer Tab"]]
    ]

   ]
  )


